module.exports = __webpack_public_path__ + "static/step2_mission_pay_card_1-edc194600cd38527b6d82c66b33318d0.svg";